<template>
    <div class="main main-padding">
        <!--查询时间栏-->
        <div class="data_select">
            <Row :gutter="10" style="width: 80%;">
                <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
            </Row>
        </div>
        <!--导出产品信息-->
        <div slot="extra" class="table-list-right-btn">
            <Button type="primary" @click.native="downloadProData()">导出各产品使用数据</Button>
        </div>
        <!--基础数据-->
        <Row :gutter="10" style="margin-top: 20px;">
            <Col
                :xs="12"
                :sm="12"
                :md="8"
                :lg="6"
                :xl="4"
                class="school-mian-cards"
                @click.native="lookDataDetailsTab('classInstallScreenDetails')"
            >
            <infor-card
                style="cursor: pointer;"
                id-name="classCount"
                :end-val="baseData.classCount"
                iconType="md-school"
                fontSize="20px"
                color="#39C6E9"
                textColor="#39C6E9"
                intro-text="使用大屏班级数"
            ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="4"
                 class="school-mian-cards"
                 @click.native="lookDataDetailsTab('bindScreenClassNum')">
            <infor-card
                v-if="baseData.bindClassNum>baseData.classCount"
                style="cursor: pointer;"
                id-name="bindClassNum"
                :end-val="baseData.bindClassNum"
                iconType="md-desktop"
                color="#39C6E9"
                textColor="#39C6E9"
                intro-text="绑定大屏班级数"
                intro-text-add="存在大屏重复绑定，点击查看！"
            ></infor-card>
            <infor-card
                v-else
                style="cursor: pointer;"
                id-name="bindClassNum"
                :end-val="baseData.bindClassNum"
                iconType="md-desktop"
                color="#39C6E9"
                textColor="#39C6E9"
                intro-text="绑定大屏班级数"
            ></infor-card>
            </Col>
            <!--如果活跃大屏数大于使用大屏班级数，则显示提醒有重复绑定-->
            <!--如果活跃大屏数小于使用大屏班级数，则不显示提醒有重复绑定-->
            <Col
                :xs="12"
                :sm="12"
                :md="8"
                :lg="6"
                :xl="4"
                class="school-mian-cards"
                @click.native="lookDataDetailsTab('activeScreenUseDetails')"
            >
            <infor-card
                style="cursor: pointer;"
                id-name="screenCount"
                :end-val="baseData.screenCount"
                iconType="ios-desktop"
                color="#39C6E9"
                textColor="#39C6E9"
                intro-text="活跃大屏数"
            ></infor-card>
            </Col>
            <Col
                :xs="12"
                :sm="12"
                :md="8"
                :lg="6"
                :xl="4"
                class="school-mian-cards"
                @click.native="lookDataDetailsTab('activeTeaUseDetails')"
            >
            <infor-card
                style="cursor: pointer;"
                id-name="teaCount"
                :end-val="baseData.teaCount"
                iconType="ios-contact"
                color="#39C6E9"
                textColor="#39C6E9"
                intro-text="活跃教师数"
            ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="4"
                 class="school-mian-cards"
                 @click.native="lookDataDetailsTab('activeStuUseDetails')">
            <infor-card
                style="cursor: pointer;"
                id-name="stuCount"
                :end-val="baseData.stuCount"
                iconType="md-contacts"
                color="#39C6E9"
                textColor="#39C6E9"
                intro-text="活跃学生数"
            ></infor-card>
            </Col>
        </Row>
        <!--大屏使用版本，活跃教师用户Top10，大屏使用场景整体分布-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="top-tea-screen-dis">
            <pie-charts
                :chartsTitle="'大屏使用版本'"
                :isShowMore=false
                :isClickCharts=false
                :height="'360px'"
                :chartsId="'gx_screen_version'"
                :pieChartsName="'版本分布'"
                ref="screenVersion"
            ></pie-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="top-tea-screen-dis">
            <histogram-charts
                :chartsTitle="'活跃教师用户Top10 (可点击柱状图)'"
                :showMore=true
                :clickCharts=true
                :showLegend=false
                :showTooltip=true
                :isCustomTooltipContent=true
                :isShowDataRemind=true
                :isSHowCompany=true
                :tooltipHead="'使用：'"
                :tooltipCompany="'次'"
                :chartsId="'gx_active_top'"
                :height="'360px'"
                ref="topTeacher"
                @click-more-data="clickMoreData"
                @look-more-data="lookMoreData"
            ></histogram-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="top-tea-screen-dis">
            <pie-charts
                :chartsTitle="'大屏使用场景整体分布(可点击饼图)'"
                :isShowMore=true
                :isClickCharts=true
                :height="'360px'"
                :chartsId="'gx_screen_scene_distri'"
                :pieChartsName="'场景分布'"
                ref="screenDistribution"
                @click-more-data="clickMoreData"
                @look-more-data="lookMoreData"
            ></pie-charts>
            </Col>
        </Row>
        <!--大屏使用详情-->
        <Row :gutter="10">
            <!--左边统计个数列-->
            <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <!--学校大屏使用教师人数-->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(1)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="screenUseTeaCount"
                    :end-val="baseData.screenUseTeaCount"
                    iconType="md-laptop"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="学校大屏使用教师人数"
                ></infor-card>
                </Col>
            </Row>
            <!--学校移动授课助手用户数量-->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(2)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="assistantUserCount"
                    :end-val="baseData.assistantUserCount"
                    iconType="md-phone-portrait"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="学校移动授课助手用户数量"
                ></infor-card>
                </Col>
            </Row>
            <!--学校智能PC使用人数-->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(3)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="intelligentUserCount"
                    :end-val="baseData.intelligentUserCount"
                    iconType="logo-youtube"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="学校智能PC使用人数"
                ></infor-card>
                </Col>
            </Row>
            <!--备课使用人数-->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(4)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="prepareLessonsCount"
                    :end-val="baseData.prepareLessonsCount"
                    iconType="md-bookmarks"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="备课使用人数"
                ></infor-card>
                </Col>
            </Row>
            <!--微课上传数量-->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(7)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="microClassUploadNum"
                    :end-val="baseData.microClassUploadNum"
                    iconType="md-bookmarks"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="微课上传数量"
                ></infor-card>
                </Col>
            </Row>
            <!-- 资源上传人数详情 -->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(5)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="resourceNum"
                    :end-val="baseData.resourceNum"
                    iconType="ios-contacts"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="资源上传数量"
                ></infor-card>
                </Col>
            </Row>
            <!--布置作业数量-->
            <Row
                :gutter="10"
                style="margin-top: 10px;cursor: pointer;"
                @click.native="updateShowType(6)"
            >
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <infor-card
                    id-name="homeworkCount"
                    :end-val="baseData.homeworkCount"
                    iconType="ios-copy"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="布置作业数量"
                ></infor-card>
                </Col>
            </Row>
            </Col>
            <!--右边柱形图列-->
            <Col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
            <!--大屏使用次数Top10教师 (可点击柱状图)-->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===1">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'大屏使用次数Top10教师 (可点击柱状图)'"
                    :isShowMore=true
                    :isClickCharts=true
                    :chartsId="'gx_tea_top'"
                    :height="'860px'"
                    :productKey="'1'"ygggg=""
                    :histogramTooltip="'useSecond'"
                    ref="screenUserDetail"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></histogram-charts>
                </Col>
            </Row>
            <!--移动授课助手使用次数Top10教师 (可点击柱状图)-->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===2">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'移动授课助手使用次数Top10教师 (可点击柱状图)'"
                    :isShowMore=true
                    :isClickCharts=true
                    :chartsId="'gx_mobile_top'"
                    :height="'860px'"
                    :productKey="'2'"
                    :histogramTooltip="'useSecond'"
                    ref="mobileUserDetail"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></histogram-charts>
                </Col>
            </Row>
            <!-- 智能PC使用次数Top10教师 (可点击柱状图)-->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===3">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'智能PC使用次数Top10教师 (可点击柱状图)'"
                    :isShowMore=true
                    :isClickCharts=true
                    :chartsId="'gx_PC_top'"
                    :height="'860px'"
                    :productKey="'4'"
                    :histogramTooltip="'useSecond'"
                    ref="pcUserDetail"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></histogram-charts>
                </Col>
            </Row>
            <!-- 备课助手使用次数Top10教师 (可点击柱状图) -->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===4">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'备课助手使用次数Top10教师 (可点击柱状图)'"
                    :isShowMore=true
                    :isClickCharts=true
                    :chartsId="'gx_prepare_class_top'"
                    :height="'860px'"
                    :productKey="'3'"
                    :histogramTooltip="'useSecond'"
                    ref="preUseDetail"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></histogram-charts>
                </Col>
            </Row>
            <!-- 微课上传数量top10-->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===7">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'微课上传数量Top10教师（可点击柱状图）'"
                    :isShowMore=false
                    :isClickCharts=true
                    :chartsId="'gx_micro_upload_top'"
                    :height="'860px'"
                    :histogramTooltip="'useSecond'"
                    ref="microUpload"
                    @click-more-data="clickMoreData"
                ></histogram-charts>
                </Col>
            </Row>
            <!--资源上传次数Top10教师(可点击柱状图)-->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===5">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'资源上传次数Top10教师(可点击柱状图)'"
                    :isShowMore=false
                    :isClickCharts=true
                    :chartsId="'gx_resource_top'"
                    :height="'860px'"
                    :histogramTooltip="'useSecond'"
                    ref="resourceTea"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></histogram-charts>
                </Col>
            </Row>
            <!--布置作业Top10教师-->
            <Row :gutter="10" style="margin-top: 10px;" v-if="showType===6">
                <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <tea-assign-homework ref="teaAssignHomework"></tea-assign-homework>
                </Col>
            </Row>
            </Col>
        </Row>
        <!--  大屏使用趋势图-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <line-charts
                :chartsTitle="'大屏使用趋势图'"
                :chartsId="'gx_screen_trend'"
                :lineCompany="'块'"
                ref="screenDayUserTrend"
            ></line-charts>
            </Col>
        </Row>
        <!-- 学校使用产品详情-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <Card :bordered="true">
                <sch-use-detail ref="schUseDetails"></sch-use-detail>
            </Card>
            </Col>
        </Row>
        <!-- 学校使用率-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <Card :bordered="true">
                <ratio-modal ref="ratioModals" :startDate="startDate" :endDate="endDate"></ratio-modal>
            </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
    import dateSelect from "../../components/dateSelect.vue";//时间选择器
    import inforCard from "../../components/inforCard.vue";//数据卡片
    import ratioModal from "./modules/ratioModal.vue";//学校使用率
    import schUseDetail from "./modules/schUseDetail.vue";//学校使用产品详情
    import teaAssignHomework from "./modules/teaAssignHomework.vue";//教师布置作业详情
    import HistogramCharts from "../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../components/charts/LineCharts.vue";//折线图
    import {
        findGiveHomeWork,
        findTeaUserNum,
        findSchoolUseCount,
        findTeaWorkCount,
        getScreenVersion,
        findActiveTeacherTop,
        findTeacherScenes,
        findSceneDetails,
        findTeaWorkUpload,
        getSchoolScreenMap,
        getMicroLessonCount,
        getMicroLessonTop
    } from "../../service/api.js";

    export default {
        name: "board-main",
        data() {
            return {
                schoolId: this.$route.query.schoolId,//学校id
                schoolName: this.$route.query.schoolName,//学校名称
                startDate: this.$route.query.startDate === undefined ? "" : this.$route.query.startDate,//开始时间，如果没有定义则置为空
                endDate: this.$route.query.endDate === undefined ? "" : this.$route.query.endDate,//结束时间，如果没有定义则置为空
                baseData: {
                    //基础数据
                    classCount: 0,//使用大屏班级数
                    screenCount: 0,//活跃大屏数
                    teaCount: 0,//活跃教师数
                    stuCount: 0,//活跃学生数
                    screenUseTeaCount: 0,//学校大屏使用教师人数
                    assistantUserCount: 0,//学校移动授课助手用户数量
                    intelligentUserCount: 0,//学校智能PC使用人数
                    prepareLessonsCount: 0,//备课使用人数
                    homeworkCount: 0,//布置作业数量
                    resourceNum: 0,//资源上传人数
                    bindClassNum: 0,//绑定大屏班级数
                    microClassUploadNum: 0//微课上传数量
                },
                showType: 1, //动态显示柱状图，默认为1
                activeTeacherList: [],//活跃教师Top10数据集合
                microClassList: [],//微课上传教师Top10数据集合
                proUseTopList: [],//各产品使用top10数据
                resourceTeaLists: [],//资源上传top10教师数据
            };
        },
        components: {
            //组件
            schUseDetail,//学校使用产品详情
            ratioModal,//学校使用率
            dateSelect,//日期选择器
            inforCard,//数据卡片
            teaAssignHomework,//教师布置作业详情
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 点击查看详细表格数据
             */
            lookDataDetailsTab(tabsName) {
                //如果活跃大屏数大于使用大屏班级数，则显示提醒有重复绑定，并传值1,如果活跃大屏数小于使用大屏班级数，则不显示提醒有重复绑定，并传值-1
                this.$router.push({
                    name: "dataDetailsTab",
                    query: {
                        schoolId: this.schoolId,
                        parentalStartDate: this.startDate,//主页面选择的开始时间
                        parentalEndDate: this.endDate,//主页面选择的结束时间
                        schoolName: this.schoolName,
                        tabsName: tabsName,
                        isShowRemind: this.baseData.bindClassNum > this.baseData.classCount ? 1 : -1
                    }
                });
            },
            /**
             * 点击查看更多数据
             */
            lookMoreData(chartsId, productKey) {
                let routeData = {};
                if (chartsId === 'gx_active_top') {
                    //点击查看活跃教师top10的更多数据
                    routeData = this.$router.resolve({
                        name: "activeTeaTopDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            routerName: "boardMain",
                            parentalStartDate: this.startDate,
                            parentalEndDate: this.endDate,
                            type: 1 //戴特教育：1；一起作业：2
                        }
                    });
                } else if (chartsId === 'gx_screen_scene_distri') {
                    //点击查看大屏使用场景整体分布的更多数据
                    routeData = this.$router.resolve({
                        name: "screenDistriDetails",
                        query: {
                            schoolId: this.schoolId,
                            routerName: "boardMain",
                            schoolName: this.schoolName,
                            startDate: this.startDate,
                            endDate: this.endDate
                        }
                    });
                } else {
                    //点击查看教师使用各产品的更多数据
                    routeData = this.$router.resolve({
                        name: "teaUseProduct",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            parentalStartDate: this.startDate,
                            parentalEndDate: this.endDate,
                            productKey: productKey
                        }
                    });
                }
                window.open(routeData.href, "_parent");
            },
            /**
             *点击图表
             */
            clickMoreData(type,params, chartsId, productKey) {
                if (chartsId === 'gx_active_top') {
                    //点击查看活跃教师top10的更多数据
                    this.$router.push({
                        name: "activeTeaDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            routerName: "boardMain",
                            selfStartDate: this.startDate,
                            selfEndDate: this.endDate,
                            userId: this.activeTeacherList[params.dataIndex].userId,
                            tabsName: "",
                            isShowRemind: "",
                            teaName: 'notAddTime',
                            sourceType: 1
                        }
                    });
                } else if (chartsId === 'gx_screen_scene_distri') {
                    //点击查看大屏使用场景整体分布的更多数据
                    this.$router.push({
                        name: "teaUserScreenDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            routerName: "boardMain",
                            startDate: this.startDate,
                            endDate: this.endDate,
                            codingKey: params.data.codingKey  //场景编码
                        }
                    });
                } else if (chartsId === 'gx_resource_top') {
                    //点击查看资源上传top10教师的更多数据
                    this.$router.push({
                        name: "resourceDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            selfStartDate: this.startDate,
                            selfEndDate: this.endDate,
                            userId: this.resourceTeaLists[params.dataIndex].userId
                        }
                    });
                }else if (chartsId === 'gx_micro_upload_top') {
                    //点击查看微课上传top10教师的更多数据
                    this.$router.push({
                        name: "microDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            selfStartDate: this.startDate,
                            selfEndDate: this.endDate,
                            userId: this.microClassList[params.dataIndex].user_id
                        }
                    });
                } else {
                    //点击查看教师使用各产品的更多数据
                    this.$router.push({
                        name: "proUseDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            selfStartDate: this.startDate,
                            selfEndDate: this.endDate,
                            proKey: productKey,
                            userId: this.proUseTopList[params.dataIndex].userId,
                            routerResource: -1
                        }
                    });
                }
            },
            /**
             * 导出产品信息
             */
            downloadProData() {
                let url =
                    process.env.VUE_APP_APIURL +
                    "/website/school/exportScreenToExcel?schoolId=" +
                    this.schoolId +
                    "&startDate=" +
                    this.startDate +
                    "&endDate=" +
                    this.endDate;
                let iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = url;
                iframe.onload = function () {
                    document.body.removeChild(iframe);
                };
                document.body.appendChild(iframe);
            },
            /**
             * 获取学校使用数量
             */
            async getSchoolUseCount() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate
                };
                await findSchoolUseCount(params)
                    .then(function (data) {
                        _this.baseData.screenCount = data.screenCount; //获取活跃大屏数量
                        _this.baseData.stuCount = data.studentCount; //获取活跃学生数
                        _this.baseData.classCount = data.classCount; //获取班级使用数量
                        _this.baseData.teaCount = data.teacherCount; //获取活跃教师数量
                        _this.baseData.bindClassNum = data.bindingClassCount; //获取绑定大屏的班级数量
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取微课上传数量
             */
            async queryMicroLessonCount() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    sTime:  _this.startDate + " 00:00:00",
                    eTime: _this.endDate + " 23:59:59"
                };
                await getMicroLessonCount(params)
                    .then(function (data) {
                        _this.baseData.microClassUploadNum = data; //获取活跃大屏数量
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏使用版本
             */
            async getScreenVersion() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    type: 1 //戴特教育：1；一起作业：2
                };
                await getScreenVersion(params)
                    .then(function (data) {
                        let versionList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < versionList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = versionList[i].count;
                            obj.name = versionList[i].product_version;
                            dataArr.push(obj);
                            nameArr.push(versionList[i].product_version);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenVersion.initDataSource(versionList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取活跃教师用户Top10数据
             */
            async getActiveTeacherTop() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    type: 1 //戴特教育：1；一起作业：2
                };
                await findActiveTeacherTop(params)
                    .then(function (data) {
                        _this.activeTeacherList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < _this.activeTeacherList.length; i++) {
                            xDataArr.push(_this.activeTeacherList[i].fullName);
                            seriesDataArr.push(_this.activeTeacherList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.topTeacher.initDataSource(_this.activeTeacherList.length>0, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取教师上传微课Top10数据
             */
            async queryMicroLessonTop() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    sTime:  _this.startDate + " 00:00:00",
                    eTime: _this.endDate + " 23:59:59"
                };
                await getMicroLessonTop(params)
                    .then(function (data) {
                        _this.microClassList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < _this.microClassList.length; i++) {
                            xDataArr.push(_this.microClassList[i].realname);
                            seriesDataArr.push(_this.microClassList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.microUpload.initDataSource(_this.microClassList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏使用场景整体分布
             */
            async getTeacherScenes() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    type: 1 //戴特教育：1；一起作业：2
                };
                await findTeacherScenes(params)
                    .then(function (data) {
                        let sceneUseList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < sceneUseList.length; i++) {
                            let obj = {};
                            obj.value = sceneUseList[i].count;
                            obj.name = sceneUseList[i].clsName;
                            obj.codingKey = sceneUseList[i].coding_key;
                            dataArr.push(obj);
                            nameArr.push(sceneUseList[i].clsName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenDistribution.initDataSource(sceneUseList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取布置作业数量
             */
            async findHomeworkCount() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate + " 00:00:00",
                    endDate: _this.endDate + " 23:59:59"
                };
                await findGiveHomeWork(params)
                    .then(function (data) {
                        _this.baseData.homeworkCount = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取学校大屏使用教师人数数据、学校移动授课助手用户数量、获取备课使用人数、获取学校智能PC使用人数
             */
            async getTeaUserNum() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate
                };
                await findTeaUserNum(params)
                    .then(function (data) {
                        if (data.length > 0) {
                            for (let i = 0; i < data.length; i++) {
                                switch (data[i].type) {
                                    case 1:
                                        _this.baseData.screenUseTeaCount = data[i].num; //获取学校大屏使用教师人数数据
                                        break;
                                    case 2:
                                        _this.baseData.assistantUserCount = data[i].num; //获取学校移动授课助手用户数量
                                        break;
                                    case 3:
                                        _this.baseData.prepareLessonsCount = data[i].num; //获取备课使用人数
                                        break;
                                    case 4:
                                        _this.baseData.intelligentUserCount = data[i].num; //获取学校智能PC使用人数
                                        break;
                                }
                            }
                        } else {
                            //如果后台数据为空，值设为默认值0
                            _this.baseData.screenUseTeaCount = _this.baseData.assistantUserCount = _this.baseData.prepareLessonsCount = _this.baseData.intelligentUserCount = 0;
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取各产品使用top10数据
             * val： 1 大屏；2 移动授课；3：智能PC；4 备课助手
             */
            async getSceneDetails(val) {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    proType: val
                };
                await findSceneDetails(params)
                    .then(function (data) {
                        _this.proUseTopList = data;
                        let nameArr = [];
                        let numArr = [];
                        for (let i = 0; i < _this.proUseTopList.length; i++) {
                            nameArr.push(_this.proUseTopList[i].fullName);
                            numArr.push(_this.proUseTopList[i].count);
                        }
                        //渲染图表
                        switch (val) {
                            case "1":
                                _this.$refs.screenUserDetail.initDataSource(_this.proUseTopList, nameArr, numArr);
                                break;
                            case "2":
                                _this.$refs.mobileUserDetail.initDataSource(_this.proUseTopList, nameArr, numArr);
                                break;
                            case "3":
                                _this.$refs.preUseDetail.initDataSource(_this.proUseTopList, nameArr, numArr);
                                break;
                            case "4":
                                _this.$refs.pcUserDetail.initDataSource(_this.proUseTopList, nameArr, numArr);
                                break;

                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取资源上传Top10教师数据
             */
            async findUseLists() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate + " 00:00:00",
                    endDate: _this.endDate + " 23:59:59"
                };
                await findTeaWorkUpload(params)
                    .then(function (data) {
                        _this.resourceTeaLists = data;
                        let nameArr = [];
                        let numArr = [];
                        for (let i = 0; i < _this.resourceTeaLists.length; i++) {
                            nameArr.push(_this.resourceTeaLists[i].userRealName);
                            numArr.push(_this.resourceTeaLists[i].num);
                        }
                        //渲染图表
                        _this.$refs.resourceTea.initDataSource(_this.resourceTeaLists, nameArr, numArr);

                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取资源上传人数
             */
            async getTeaWorkCount() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate + " 00:00:00",
                    endDate: _this.endDate + " 23:59:59"
                };
                await findTeaWorkCount(params)
                    .then(function (data) {
                        _this.baseData.resourceNum = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏使用趋势图
             */
            async getSchoolScreenMap() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    type: 3,
                    state: 1  //戴特教育：1；一起作业：2
                };
                await getSchoolScreenMap(params)
                    .then(function (data) {
                        let curResultData = data;
                        let dateArr = [];
                        let numberArr = [];
                        for (let i = 0; i < curResultData.length; i++) {
                            dateArr.push(curResultData[i].date);
                            numberArr.push(curResultData[i].number);
                        }
                        //渲染图表
                        _this.$refs.screenDayUserTrend.initDataSource(curResultData, dateArr, numberArr);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /*
             * 控制动态显示柱状图
             */
            updateShowType(type) {
                this.showType = type;
                this.$nextTick(() => {
                    if (this.showType === 1) {
                        //大屏使用场景详情柱形图展示
                        this.getSceneDetails("1")
                    } else if (this.showType === 2) {
                        //移动授课助手使用详情柱形图展示
                        this.getSceneDetails("2");
                    } else if (this.showType === 3) {
                        //智能PC教师使用详情柱形图展示
                        this.getSceneDetails("4");
                    } else if (this.showType === 4) {
                        //备课使用人数详情柱形图展示
                        this.getSceneDetails("3");
                    } else if (this.showType === 5) {
                        //资源上传Top10教师柱形图展示
                        this.findUseLists();
                    } else if (this.showType === 6) {
                        //布置作业Top10教师柱形图展示
                        this.$refs.teaAssignHomework.initDate(this.startDate, this.endDate);
                    }else if (this.showType === 7) {
                        //微课上传Top10教师柱形图展示
                        this.queryMicroLessonTop();
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime(startDate, endDate) {
                let _this = this;
                _this.startDate = startDate;
                _this.endDate = endDate;
                _this.showType = 1;
                //选择完日期后重新请求接口
                //获取学校使用数量
                _this.getSchoolUseCount();
                //获取大屏使用版本集合
                _this.getScreenVersion();
                //获取活跃教师top10 数据
                _this.getActiveTeacherTop();
                //获取大屏使用场景整体分布
                _this.getTeacherScenes();
                //获取大屏使用top10集合
                _this.getSceneDetails("1");
                // 获取学校大屏使用教师人数数据、学校移动授课助手用户数量、获取备课使用人数、获取学校智能PC使用人数
                _this.getTeaUserNum();
                // 获取布置作业数量
                _this.findHomeworkCount();
                //获取资源上传人数
                _this.getTeaWorkCount();
                //获取大屏使用趋势图
                _this.getSchoolScreenMap();
                //获取微课上传数量
                _this.queryMicroLessonCount();
                _this.$nextTick(() => {
                    //将主页面选择的开始结束时间传给学校使用产品详情页面
                    _this.$refs.schUseDetails.remTime(_this.startDate, _this.endDate);
                })
            }
        },
        mounted() {
            let _this = this;
            _this.$nextTick(() => {
                //修改公共属性学校名称
                _this.$store.commit("SET_TOPHEADERNAME", _this.schoolName);
                //当月开始日期
                _this.startDate = this.startDate === "" ? _this.$utils.getMonthStartDate() : _this.startDate;
                //当月结束日期
                _this.endDate = _this.endDate === "" ? _this.$utils.getMonthEndDate() : _this.endDate;
                //初始化时间组件开始、结束日期,获取默认时间
                _this.$refs.dateSelect.setDate(_this.startDate, _this.endDate);
                //获取学校使用基础数据
                _this.getSchoolUseCount();

                //获取大屏使用版本集合
                _this.getScreenVersion();
                //获取活跃教师top10 数据
                _this.getActiveTeacherTop();
                //获取大屏使用场景整体分布
                _this.getTeacherScenes();
                //获取大屏使用top10集合
                _this.getSceneDetails("1");
                // 获取布置作业数量
                _this.findHomeworkCount();
                // 获取学校大屏使用教师人数数据、学校移动授课助手用户数量、获取备课使用人数、获取学校智能PC使用人数
                _this.getTeaUserNum();
                //获取资源上传人数
                console.log("我走了这里！");
                _this.getTeaWorkCount();
                //获取大屏使用趋势图
                _this.getSchoolScreenMap();
                //获取微课上传的数量
                _this.queryMicroLessonCount();
                // 将主页面选择的开始结束时间传给学校使用产品详情页面
                _this.$refs.schUseDetails.remTime(_this.startDate, _this.endDate);
            });
        }
    }
    ;
</script>

<style lang="scss" scoped>
    @import "../../style/home";
</style>
<style lang="scss">
    .school-mian-cards.ivu-col-span-xl-4 {
        width: 20%;
    }

    .top-tea-screen-dis.ivu-col-span-xl-6 {
        width: 33.33%;
    }

    .data_select.time-slot .ivu-col-span-lg-4 {
        display: block;
        width: 23%;
    }
</style>
